import { AllCommunityModule, ModuleRegistry } from 'ag-grid-community'
import { AllEnterpriseModule, LicenseManager } from 'ag-grid-enterprise'

ModuleRegistry.registerModules([AllEnterpriseModule, AllCommunityModule])
LicenseManager.setLicenseKey(import.meta.env.VITE_AG_GRID_LICENSE_KEY || '')
